import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { setDefinitions } from '../../actions/SetDefinitions';
const schdulesAdapter = createEntityAdapter({
    selectId: (s) => s.id,
    sortComparer: (a, b) => {
        if (a.next_run < b.next_run) {
            return -1;
        }
        else if (a.next_run > b.next_run) {
            return 1;
        }
        else {
            return a.id - b.id;
        }
    },
});
export const schedulesSlice = createSlice({
    name: 'schedules',
    initialState: schdulesAdapter.getInitialState(),
    reducers: {
        schedulesCleared(s) { schdulesAdapter.removeAll(s); },
        scheduleUpdated(s, a) { schdulesAdapter.setOne(s, a); },
        scheduleDeleted(s, a) { schdulesAdapter.removeOne(s, a); },
        scheduleReplaced(s, a) { schdulesAdapter.setAll(s, a); },
    },
    extraReducers: (builder) => {
        builder
            .addCase(setDefinitions, (s, action) => {
            schdulesAdapter.setAll(s, action.payload.schedules);
        });
    }
});
export const { schedulesCleared, scheduleUpdated, scheduleDeleted, scheduleReplaced } = schedulesSlice.actions;
export const scheduleAdded = scheduleUpdated;
export default schedulesSlice.reducer;
export const allSchedules = schdulesAdapter.getSelectors().selectAll;
